// redux/actions/mesAvantagesActions.js

// ===================== ACTION TYPES =====================
export const SET_MES_AVANTAGES_LOADING = "SET_MES_AVANTAGES_LOADING";

// Fetch mes avantages
export const FETCH_MES_AVANTAGES_REQUEST = "FETCH_MES_AVANTAGES_REQUEST";
export const FETCH_MES_AVANTAGES_SUCCESS = "FETCH_MES_AVANTAGES_SUCCESS";
export const FETCH_MES_AVANTAGES_FAILURE = "FETCH_MES_AVANTAGES_FAILURE";

// ===================== ACTION CREATORS =====================

// Loading
export const setMesAvantagesLoading = (isLoading) => ({
    type: SET_MES_AVANTAGES_LOADING,
    payload: isLoading,
});

// Fetch mes avantages
// ✅ CORRECTION: Ne prend plus de userId car on utilise Authentication dans le backend
export const fetchMesAvantagesRequest = () => ({
    type: FETCH_MES_AVANTAGES_REQUEST,
});

export const fetchMesAvantagesSuccess = (data) => ({
    type: FETCH_MES_AVANTAGES_SUCCESS,
    payload: data,
});

export const fetchMesAvantagesFailure = (error) => ({
    type: FETCH_MES_AVANTAGES_FAILURE,
    payload: error,
});